// removed by extract-text-webpack-plugin
module.exports = {"stuck":"Masthead__stuck-mxq0r","Base":"Masthead__Base-ZI_w_","Base--simple":"Masthead__Base--simple-3WovP Masthead__Base-ZI_w_","Nav":"Masthead__Nav-NebQS","Header":"Masthead__Header-2QMvs","Masthead":"Masthead__Masthead-31xfX","Logo":"Masthead__Logo-3QI_V","TimeStamp":"Masthead__TimeStamp-1T1aV","FullMenu":"Masthead__FullMenu-jFmHi"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Masthead/Masthead.css
 ** module id = 632
 ** module chunks = 0
 **/